import store from '@/store'
import { getData, postData } from '@core/utils/http/general'

//* Return resource list
export const getResourses = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsRecurso')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Save changes (new|update|delete)
export const saveChanges = dataParam => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wsRecurso')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('token', store.state.cuenta.session.token)
  Object.entries(dataParam).forEach(element => { data.append(element[0], element[1]) })

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data)
    })
    .catch(err => { reject(err) })
})
